document.addEventListener("DOMContentLoaded", function () {
   new Swiper('.hero-slider', {
    loop: true,
    navigation: {
      nextEl: '.custom-swiper-next',
      prevEl: '.custom-swiper-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const input = document.querySelector('.header-toolbar__search input');
//   const container = document.querySelector('.header-toolbar__search');

//   function updateIconVisibility() {
//     if (document.activeElement === input || input.value.trim() !== '') {
//       container.classList.add('hide-icon');
//     } else {
//       container.classList.remove('hide-icon');
//     }
//   }

//   if (input && container) {
//     input.addEventListener('focus', updateIconVisibility);
//     input.addEventListener('blur', updateIconVisibility);
//     input.addEventListener('input', updateIconVisibility); // Trigger on typing
//   }
// });



/*document.addEventListener('DOMContentLoaded', function () {
    $('.collection-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });*/

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('[id^="shopify-section-template--"][id$="__cart-items"]');
  const mainContent = document.getElementById("MainContent");

  if (section && mainContent) {
    mainContent.classList.add("custom-cart");
  }
});


  document.querySelectorAll('.accordion-header').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.parentElement;
      item.classList.toggle('active');
    });
  });

/*document.addEventListener('DOMContentLoaded', function () {
    const cartItems = document.querySelector('cart-items');
    const mainEl = document.querySelector('main.custom-cart, main.cart_empty');

    if (!cartItems || !mainEl) return;

    function updateMainClass() {
      if (cartItems.classList.contains('is-empty')) {
        mainEl.classList.remove('custom-cart');
        mainEl.classList.add('cart_empty');
      } else {
        mainEl.classList.remove('cart_empty');
        mainEl.classList.add('custom-cart');
      }
    }

    // Initial check on load
    updateMainClass();

    // Watch for class changes
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'class') {
          updateMainClass();
        }
      }
    });

    observer.observe(cartItems, { attributes: true, attributeFilter: ['class'] });
  });*/

document.addEventListener('DOMContentLoaded', function () {
  function initCartWatcher() {
    const cartItems = document.querySelector('cart-items');
    const mainEl = document.querySelector('main.custom-cart, main.cart_empty');

    if (!cartItems || !mainEl) return;

    function updateMainClass() {
      if (cartItems.classList.contains('is-empty')) {
        mainEl.classList.remove('custom-cart');
        mainEl.classList.add('cart_empty');
      } else {
        mainEl.classList.remove('cart_empty');
        mainEl.classList.add('custom-cart');
      }
    }

    // Initial class check
    updateMainClass();

    // Watch for class changes
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'class') {
          updateMainClass();
        }
      }
    });

    observer.observe(cartItems, { attributes: true, attributeFilter: ['class'] });
  }

  // Wait for cart-items to be present
  const cartCheck = setInterval(() => {
    if (document.querySelector('cart-items')) {
      clearInterval(cartCheck);
      initCartWatcher();
    }
  }, 100);
});


function togglePassword() {
    const passwordInput = document.getElementById("RegisterForm-password");
    const eyeIcon = document.getElementById("eye-icon");

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      eyeIcon.classList.remove("fa-eye");
      eyeIcon.classList.add("fa-eye-slash");
    } else {
      passwordInput.type = "password";
      eyeIcon.classList.remove("fa-eye-slash");
      eyeIcon.classList.add("fa-eye");
    }
  }

  function togglePasswordlogin() {
    const passwordInput = document.getElementById("CustomerPassword");
    const eyeIcon = document.getElementById("eye-icon");

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      eyeIcon.classList.remove("fa-eye");
      eyeIcon.classList.add("fa-eye-slash");
    } else {
      passwordInput.type = "password";
      eyeIcon.classList.remove("fa-eye-slash");
      eyeIcon.classList.add("fa-eye");
    }
  }


document.addEventListener("DOMContentLoaded", function () {
    function showRecoverForm() {
      var recover = document.getElementById('recoverForm');
      var login = document.getElementById('loginForm');
      if (recover && login) {
        recover.style.display = 'block';
        login.style.display = 'none';
      }
    }

    function hideRecoverForm() {
      var recover = document.getElementById('recoverForm');
      var login = document.getElementById('loginForm');
      if (recover && login) {
        recover.style.display = 'none';
        login.style.display = 'block';
      }
    }

    // Attach globally if needed
    window.showRecoverForm = showRecoverForm;
    window.hideRecoverForm = hideRecoverForm;

    // Auto open recover form if hash in URL
    if (window.location.hash === '#recover') {
      showRecoverForm();
    }
  });


  /**to hide thank u message */

document.addEventListener("DOMContentLoaded", function() {
  const formSuccess = document.querySelector('.newsletter-success-message');

  // Clean the URL first if it contains the query param
  if (window.location.href.indexOf('customer_posted=true') > -1) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }

  if (formSuccess) {
    // Hide the success message after 4 seconds
    setTimeout(() => {
      formSuccess.style.display = 'none';
    }, 4000);

    // Refresh page after 5 seconds (optional)
    setTimeout(() => {
      window.location.reload();
    }, 5000);
  }
});

document.addEventListener("DOMContentLoaded", function () {

  // Select all filter text labels
  const items = document.querySelectorAll(".facet-checkbox__text-label");

  items.forEach(function (item) {
    let text = item.textContent.trim();

    // Replace ending " SL" with " Silver"
    if (text.endsWith(" SL")) {
      item.textContent = text.replace(" SL", " SILVER");
    }
  });

});


document.addEventListener("DOMContentLoaded", function () {
    const currentURL = window.location.pathname;

    // Loop all facet labels
    document.querySelectorAll(".facet-checkbox__text-label").forEach(function (item) {
        let text = item.textContent.trim();

        // CASE 1: Diamond collection → remove "18 G"
        if (currentURL.includes("/collections/diamond")) {
            text = text.replace(/\s*18\s*G\b/gi, "");
        }

        // CASE 2: Gold or 18k collection → change 18 G → 18kt
        if (currentURL.includes("/collections/gold") || currentURL.includes("/collections/18k")) {
            text = text.replace(/\s*18\s*G\b/gi, " 18KT");
        }

        item.textContent = text;
    });
});

document.addEventListener("DOMContentLoaded", function () {

  // Check if the current URL contains /collections/platinum
  if (window.location.href.includes("/collections/platinum")) {

    // Select all facet labels
    document.querySelectorAll(".facet-checkbox__text-label").forEach(function (el) {

      let text = el.innerText.trim();

      // If name ends with " PL", change only the "PL" part
      if (text.endsWith(" PL")) {
        el.innerText = text.replace(/ PL$/, " PLATINUM");
      }

    });

  }

});



(function () {

  function isMobile() {
    return window.innerWidth <= 600;
  }

  // Extract rupee "₹ 515.00"
  function extractRupee(text) {
    if (!text) return null;
    const m = text.replace(/\u00A0/g, ' ').match(/₹\s*[\d,]+(?:\.\d+)?/);
    return m ? m[0].replace(/\s+/, ' ') : null;
  }

  function updateLabels() {
    if (!isMobile()) return; // ⛔ run only below 600px

    // 1) Total price
    document.querySelectorAll('td.cart-item__totals .price, td.cart-item__totals .price--end')
      .forEach(function (el) {
        const raw = el.innerText || '';
        const price = extractRupee(raw) || raw.trim();
        if (!price) return;
        if (!/^Total[:\s]/i.test(raw.trim())) {
          el.innerText = 'Total: ' + price;
        }
      });

    // 2) Unit price
    document.querySelectorAll('td.cart_item_price .product-option')
      .forEach(function (el) {
        const raw = el.innerText || '';
        const price = extractRupee(raw) || raw.trim();
        if (!price) return;
        if (!/^Price[:\s]/i.test(raw.trim())) {
          el.innerText = 'Price: ' + price;
        }
      });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', updateLabels);

  // Run on resize
  window.addEventListener('resize', updateLabels);

  // Run on AJAX updates
  const observer = new MutationObserver(() => updateLabels());
  observer.observe(document.body, { childList: true, subtree: true });

})();

/**hover menu */



  // Run only on devices that support hover (desktop)
/*if (window.matchMedia('(hover: hover)').matches) {

  let closeTimer = null;

  document.querySelectorAll('header-menu details').forEach(details => {

    const summary = details.querySelector('summary');
    if (!summary) return;

    const openMenu = () => {
      clearTimeout(closeTimer);

      // close other sibling details at same level
      const siblings = details.parentElement.querySelectorAll(':scope > details');
      siblings.forEach(el => {
        if (el !== details) el.removeAttribute('open');
      });

      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    };

    details.addEventListener('mouseenter', openMenu);

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(closeMenu, 500); 
    });

  });

}*/



/*only for main menu hover*/
if (window.matchMedia('(hover: hover)').matches) {

  let closeTimer = null;

  // ONLY first-level menu items
  document.querySelectorAll('header-menu > details').forEach(details => {

    const summary = details.querySelector('summary');
    if (!summary) return;

    const openMenu = () => {
      clearTimeout(closeTimer);

      // Close other main menus
      document.querySelectorAll('header-menu > details').forEach(el => {
        if (el !== details) el.removeAttribute('open');
      });

      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    };

    details.addEventListener('mouseenter', openMenu);

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(closeMenu, 300);
    });

  });
}

document.addEventListener("DOMContentLoaded", function () {
  const link = document.querySelector('#HeaderDrawer-jewellery-savings-plan');

  if (link) {
    const img = document.createElement('img');
    img.src = "//poongulazhijewellers.com/cdn/shop/t/2/assets/coin.png?v=145200753225448240231750173184";
    img.alt = "Coin";
    img.className = "coin-animation";

    // Insert image inside the link (at the beginning)
    link.prepend(img);
  }
});


document.addEventListener("DOMContentLoaded", function () {

  // Get the category text (adjust selector if needed)
  var categoryElement = document.querySelector('.pro_category');

  if (!categoryElement) return;

  var categoryText = categoryElement.textContent.toUpperCase();

  // If category contains SL
  if (categoryText.includes('SL')) {
    var button = document.querySelector('.btn.make-btn');
    if (button) {
      button.style.display = 'none';
    }
  }

});


document.addEventListener("DOMContentLoaded", function () {
  const sortSelect = document.getElementById("SortBy");
  if (!sortSelect) return;

  // Required order + labels (MATCHING YOUR VALUES)
  const desiredOrder = [
    { value: "price-descending", label: "Price high to low" },
    { value: "price-ascending", label: "Price low to high" },
    { value: "best-selling", label: "Best selling" },
    { value: "created-descending", label: "New arrivals" }
  ];

  // Store existing options
  const existing = {};
  Array.from(sortSelect.options).forEach(opt => {
    existing[opt.value] = opt;
  });

  // Remove all options
  sortSelect.innerHTML = "";

  // Add only required options in required order
  desiredOrder.forEach(item => {
    if (existing[item.value]) {
      const opt = existing[item.value];
      opt.textContent = item.label;
      sortSelect.appendChild(opt);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".facet-checkbox__text").forEach(wrapper => {
    const label = wrapper.querySelector(".facet-checkbox__text-label");
    if (!label) return;

    // Check label text
    if (label.textContent.trim() === "Out of Stock") {

      // Prevent duplicate insert
      if (wrapper.querySelector(".facet-checkbox__make-to-order")) return;

      const span = document.createElement("span");
      span.className = "facet-checkbox__make-to-order";
      //span.textContent = "(Make to Order)";

      // Insert after label
      label.after(span);
    }
  });
});


/**haram */
// document.addEventListener("DOMContentLoaded", function () {

//   const haramTypes = [
//     "ANTIQUE",
//     "FANCY",
//     "RODIUM",
//     "STONE",
//     "TRADITIONAL",
//     "TURKEY"
//   ].sort();

//   const currentHandle = window.location.pathname.split("/").pop();
//   if (!currentHandle.endsWith("-haram")) return;
//    if (!currentHandle.startsWith("gold-")) return;

//   // Detect current type from slug
//   let currentType = "";
//   haramTypes.forEach(type => {
//     if (currentHandle.toLowerCase().includes(type.toLowerCase())) {
//       currentType = type;
//     }
//   });

//   const filterList = document.querySelector(
//     ".facets-layout.facets-layout-list.facets__list--vertical"
//   );
//   if (!filterList) return;

//   /* ---------------------------------------
//      STEP 1: Collect existing filter values
//   ---------------------------------------- */
//   const existingValues = Array.from(
//     filterList.querySelectorAll('input[name="filter.p.m.custom.sub_category"]')
//   ).map(input => input.value);

//   /* ---------------------------------------
//      STEP 2: Add only missing haram values
//   ---------------------------------------- */
//   haramTypes.forEach((type, index) => {

//     // ❌ Skip current haram
//     if (type === currentType) return;

//     // inside li.innerHTML
  


//     // ❌ Skip if Shopify already added it
//     if (existingValues.includes(type)) return;

//     const li = document.createElement("li");
//     li.className = "list-menu__item facets__item";

//     const id = `Filter-filter.p.m.custom.sub_category-js-${index}`;

//     li.innerHTML = `
    
//       <label for="${id}" class="facets__label facet-checkbox">
//         <input
//           type="checkbox"
//           name="filter.p.m.custom.sub_category"
//           value="${type}"
//           id="${id}"
//         >
//         <svg width="16px" height="16px" viewBox="0 0 16 16">
//           <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
//         </svg>
//         <div class="svg-wrapper">
//           <svg xmlns="http://www.w3.org/2000/svg" fill="none"
//             class="icon icon-checkmark" viewBox="0 0 12 9">
//             <path fill="currentColor" fill-rule="evenodd"
//               d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
//               clip-rule="evenodd"></path>
//           </svg>
//         </div>
//         <span class="facet-checkbox__text">          
//           <span class="facet-checkbox__text-label">${type}</span>          
//         </span>
//       </label>
//     `;

//     li.querySelector("input").addEventListener("change", function () {
//       window.location.href =
//         `/collections/gold-haram?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
//     });

//     filterList.appendChild(li);
//   });

// });
document.addEventListener("DOMContentLoaded", function () {

  const haramTypes = [
    "ANTIQUE",
    "FANCY",
    "RODIUM",
    "STONE",
    "TRADITIONAL",
    "TURKEY"
  ].sort();

  const filterListSelector = ".facets-layout.facets-layout-list.facets__list--vertical";

  // ✅ Function to add missing haram filters
  function addHaramFilters() {
    const currentHandle = window.location.pathname.split("/").pop();
    if (!currentHandle.endsWith("-haram")) return;
    if (!currentHandle.startsWith("gold-")) return;

    let currentType = "";
    haramTypes.forEach(type => {
      if (currentHandle.toLowerCase().includes(type.toLowerCase())) {
        currentType = type;
      }
    });

    const filterList = document.querySelector(filterListSelector);
    if (!filterList) return;

    const existingValues = Array.from(
      filterList.querySelectorAll('input[name="filter.p.m.custom.sub_category"]')
    ).map(input => input.value);

    haramTypes.forEach((type, index) => {
      if (type === currentType) return;
      if (existingValues.includes(type)) return;

      const li = document.createElement("li");
      li.className = "list-menu__item facets__item";
      const id = `Filter-filter.p.m.custom.sub_category-js-${index}`;

      li.innerHTML = `
        <label for="${id}" class="facets__label facet-checkbox">
          <input
            type="checkbox"
            name="filter.p.m.custom.sub_category"
            value="${type}"
            id="${id}"
          >
          <svg width="16px" height="16px" viewBox="0 0 16 16">
            <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
          </svg>
          <div class="svg-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none"
              class="icon icon-checkmark" viewBox="0 0 12 9">
              <path fill="currentColor" fill-rule="evenodd"
                d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <span class="facet-checkbox__text">          
            <span class="facet-checkbox__text-label">${type}</span>          
          </span>
        </label>
      `;

      li.querySelector("input").addEventListener("change", function () {
        window.location.href = `/collections/gold-harram?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
      });

      filterList.appendChild(li);
    });
  }

  // ✅ Initial call on page load
  addHaramFilters();

  // ✅ Observe URL changes using history pushState / popstate
  let lastHref = location.href;
  const observer = new MutationObserver(() => {
    if (location.href !== lastHref) {
      lastHref = location.href;
      addHaramFilters();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ✅ Also catch back/forward navigation
  window.addEventListener("popstate", addHaramFilters);

});


/**Necklace**/

document.addEventListener("DOMContentLoaded", function () {

  const necklaceTypes = [
    "ANTIQUE",
    "CASTING",
    "CHOKER",
    "FANCY",
    "RODIUM",
    "STONE",
    "TURKEY"
  ].sort();

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-necklace collection pages
  if (!currentHandle.endsWith("-necklace")) return;
  if (!currentHandle.startsWith("gold-")) return;

  /* ---------------------------------------
     Detect current necklace type from slug
  ---------------------------------------- */
  let currentType = "";
  necklaceTypes.forEach(type => {
    if (currentHandle.toLowerCase().includes(type.toLowerCase())) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
     (to avoid duplication + keep counts)
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing necklace types
  ---------------------------------------- */
  necklaceTypes.forEach((type, index) => {

    // ❌ Skip current necklace type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-necklace-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base necklace collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-necklace?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**chain */

document.addEventListener("DOMContentLoaded", function () {

  /* ---------------------------------------
     CHAIN sub-category values (A–Z)
  ---------------------------------------- */
  const chainTypes = [
    "KARUGAMANI CHAIN",
    "MEN",
    "MUGAPPU CHAIN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-chain collection pages
  if (!currentHandle.endsWith("-chain")) return;
  if (!currentHandle.startsWith("gold-")) return;

  /* ---------------------------------------
     Detect current chain type from slug
  ---------------------------------------- */
  let currentType = "";
  chainTypes.forEach(type => {
    if (currentHandle.toLowerCase().includes(type.toLowerCase().replace(/\s+/g, "-"))) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
     (keeps Shopify counts & avoids duplicate)
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing chain values
  ---------------------------------------- */
  chainTypes.forEach((type, index) => {

    // ❌ Skip current chain type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-chain-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base chain collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-chain?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**rings */
document.addEventListener("DOMContentLoaded", function () {

  const ringTypes = [
    "COUPLE RING",
    "MEN",
    "STONE RING",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-ring collection pages
  if (!currentHandle.endsWith("-ring")) return;
  if (!currentHandle.startsWith("gold-")) return;

  /* ---------------------------------------
     Detect current ring type from slug
  ---------------------------------------- */
  let currentType = "";
  ringTypes.forEach(type => {
    if (currentHandle.toLowerCase().includes(type.toLowerCase().replace(/\s+/g, "-"))) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
     (keeps Shopify counts & avoids duplicate)
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing ring values
  ---------------------------------------- */
  ringTypes.forEach((type, index) => {

    // ❌ Skip current ring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-ring-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base ring collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-rings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**Bracelet */
document.addEventListener("DOMContentLoaded", function () {

  const braceletTypes = [
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-bracelet collection pages
  if (!currentHandle.endsWith("-bracelet")) return;
  if (
  !currentHandle.startsWith("gold-") &&
  !currentHandle.startsWith("silver-")
) return;

  /* ---------------------------------------
     Detect current bracelet type from slug
  ---------------------------------------- */
  let currentType = "";
  braceletTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
     (keeps Shopify counts & avoids duplicate)
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing bracelet values
  ---------------------------------------- */
  braceletTypes.forEach((type, index) => {

    // ❌ Skip current bracelet type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-bracelet-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base bracelet collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-bracelet?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**Earrings **/
document.addEventListener("DOMContentLoaded", function () {

  const earringTypes = [
    "DROPS",
    "JIMIKKI",
    "STUD"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-earring collection pages
  if (!currentHandle.endsWith("-earrings")) return;
  if (!currentHandle.startsWith("gold-")) return;

  /* ---------------------------------------
     Detect current earring type from slug
  ---------------------------------------- */
  let currentType = "";
  earringTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
     (keeps Shopify counts & avoids duplicate)
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing earring values
  ---------------------------------------- */
  earringTypes.forEach((type, index) => {

    // ❌ Skip current earring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-earring-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base earrings collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-earrings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**Bangles */

document.addEventListener("DOMContentLoaded", function () {

  const bangleTypes = [
    "DAILY WEAR",
    "FANCY BANGLE",    
    "WEDDING SETS"    
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-bangles collection pages
  if (!currentHandle.endsWith("-bangle")) return;
  if (!currentHandle.startsWith("gold-")) return;

  /* ---------------------------------------
     Detect current bangle type from slug
  ---------------------------------------- */
  let currentType = "";
  bangleTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing bangle values
  ---------------------------------------- */
  bangleTypes.forEach((type, index) => {

    // ❌ Skip current bangle type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-bangles-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base bangles collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-bangles?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**Kada */
document.addEventListener("DOMContentLoaded", function () {

  const kadaTypes = [
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-kada collection pages
  if (!currentHandle.endsWith("-kada")) return;
  if (!currentHandle.startsWith("gold-")) return;


  /* ---------------------------------------
     Detect current kada type from slug
  ---------------------------------------- */
  let currentType = "";
  kadaTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing kada values
  ---------------------------------------- */
  kadaTypes.forEach((type, index) => {

    // ❌ Skip current kada type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-kada-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to base kada collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/gold-kada?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**platinum rings */
document.addEventListener("DOMContentLoaded", function () {

  const ringTypes = [
    "COUPLE RINGS",
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-rings collection pages
  if (!currentHandle.endsWith("-rings")) return;

  if (!currentHandle.startsWith("platinum-")) return;
  /* ---------------------------------------
     Detect current ring type from slug
  ---------------------------------------- */
  let currentType = "";
  ringTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing ring values
  ---------------------------------------- */
  ringTypes.forEach((type, index) => {

    // ❌ Skip current ring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-rings-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to platinum rings collection
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/platinum-rings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**Diamond Rings*/

/** diamond rings */
document.addEventListener("DOMContentLoaded", function () {

  const ringTypes = [
    "UNISEX",
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-rings collection pages
  if (!currentHandle.endsWith("-rings")) return;

  if (!currentHandle.startsWith("diamond-")) return;


  /* ---------------------------------------
     Detect current ring type from slug
  ---------------------------------------- */
  let currentType = "";
  ringTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing ring values
  ---------------------------------------- */
  ringTypes.forEach((type, index) => {

    // ❌ Skip current ring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-rings-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to diamond rings collection
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/diamond-rings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**eleganza rings */
document.addEventListener("DOMContentLoaded", function () {

  const ringTypes = [  
    "MENS",   
    "WOMENS"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-ring collection pages
  if (!currentHandle.endsWith("-rings")) return;

  // ✅ Allow ONLY eleganza rings
  if (!currentHandle.startsWith("eleganza-")) return;

  /* ---------------------------------------
     Detect current ring type from slug
  ---------------------------------------- */
  let currentType = "";
  ringTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing ring values
  ---------------------------------------- */
  ringTypes.forEach((type, index) => {

    // ❌ Skip current ring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-eleganza-ring-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to Eleganza rings collection
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/eleganza-18kt-rings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});


/** Eleganza Chains */
document.addEventListener("DOMContentLoaded", function () {

  const chainTypes = [
    "MENS",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on *-chains collection pages
  if (!currentHandle.endsWith("-chain")) return;

  // ✅ Allow ONLY eleganza chains
  if (!currentHandle.startsWith("eleganza-")) return;

  /* ---------------------------------------
     Detect current chain type from slug
  ---------------------------------------- */
  let currentType = "";
  chainTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase())
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing chain values
  ---------------------------------------- */
  chainTypes.forEach((type, index) => {

    // ❌ Skip current chain type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-eleganza-chains-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to Eleganza chains collection
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/eleganza-18kt-chains?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**silver rings */


document.addEventListener("DOMContentLoaded", function () {

  // ✅ Only MEN & WOMEN for Silver Rings
  const ringTypes = [
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on silver *-ring collection pages
  if (!currentHandle.endsWith("-rings")) return;
  if (!currentHandle.startsWith("silver-")) return;

  /* ---------------------------------------
     Detect current ring type from slug
  ---------------------------------------- */
  let currentType = "";
  ringTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing silver ring values
  ---------------------------------------- */
  ringTypes.forEach((type, index) => {

    // ❌ Skip current ring type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-silver-rings-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to silver rings collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/silver-rings?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

/**silver chain */

document.addEventListener("DOMContentLoaded", function () {

  // ✅ Only MEN & WOMEN for Silver Chains
  const chainTypes = [
    "MEN",
    "WOMEN"
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  const currentHandle = window.location.pathname.split("/").pop();

  // ✅ Run only on silver *-chain collection pages
  if (!currentHandle.endsWith("-chain") && !currentHandle.endsWith("-chains")) return;
  if (!currentHandle.startsWith("silver-")) return;

  /* ---------------------------------------
     Detect current chain type from slug
  ---------------------------------------- */
  let currentType = "";
  chainTypes.forEach(type => {
    if (
      currentHandle
        .toLowerCase()
        .includes(type.toLowerCase().replace(/\s+/g, "-"))
    ) {
      currentType = type;
    }
  });

  const filterList = document.querySelector(
    ".facets-layout.facets-layout-list.facets__list--vertical"
  );
  if (!filterList) return;

  /* ---------------------------------------
     STEP 1: Collect existing Shopify filters
  ---------------------------------------- */
  const existingValues = Array.from(
    filterList.querySelectorAll(
      'input[name="filter.p.m.custom.sub_category"]'
    )
  ).map(input => input.value);

  /* ---------------------------------------
     STEP 2: Add ONLY missing silver chain values
  ---------------------------------------- */
  chainTypes.forEach((type, index) => {

    // ❌ Skip current chain type
    if (type === currentType) return;

    // ❌ Skip if Shopify already rendered it
    if (existingValues.includes(type)) return;

    const li = document.createElement("li");
    li.className = "list-menu__item facets__item";

    const id = `Filter-filter.p.m.custom.sub_category-silver-chains-${index}`;

    li.innerHTML = `
      <label for="${id}" class="facets__label facet-checkbox">
        <input
          type="checkbox"
          name="filter.p.m.custom.sub_category"
          value="${type}"
          id="${id}"
        >
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <rect width="16" height="16" fill="none" stroke="currentColor"></rect>
        </svg>
        <div class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
            class="icon icon-checkmark" viewBox="0 0 12 9">
            <path fill="currentColor" fill-rule="evenodd"
              d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5. 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <span class="facet-checkbox__text">
          <span class="facet-checkbox__text-label">${type}</span>
        </span>
      </label>
    `;

    // ✅ Redirect to silver chains collection with filter
    li.querySelector("input").addEventListener("change", function () {
      window.location.href =
        `/collections/silver-chains?filter.p.m.custom.sub_category=${encodeURIComponent(type)}`;
    });

    filterList.appendChild(li);
  });

});

